import { useCallback } from 'react';

import { rankItem } from '@tanstack/match-sorter-utils';
import { FilterFn } from '@tanstack/react-table';

export const useFuzzyFilter = <TData>() => {
  const filterFn: FilterFn<TData> = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value);

    addMeta({
      itemRank,
    });

    return itemRank.passed;
  };

  return useCallback(filterFn, []);
};
